import * as Sentry from '@sentry/react';

import { getCurrentUser } from '~/api/currentUser';

export enum Metric {
  TimeToContent = 'ui.time_to_content',
}

type User = Awaited<ReturnType<typeof getCurrentUser>>;

/*
 * This service is meant to abstract important events in our app lifecycle so that we can generate useful
 * metrics and insights into our app performance.
 */
export class MetricsServiceClass {
  timeToRenderStart: number | null = null;
  user: User | null = null;

  appMounted = (user: User | null) => {
    this.timeToRenderStart = performance.now();
    this.user = user;
  };

  appReady = () => {
    if (this.timeToRenderStart === null) return;

    Sentry.startInactiveSpan({
      name: Metric.TimeToContent,
      op: 'metric.timer',
      startTime: this.timeToRenderStart,
      attributes: {
        'sentry.op': 'metric.timer',
        'sentry.origin': 'manual.react.metrics',
        metric_type: 'custom_timer',
        client_id: this.user?.client,
      },
    }).end();

    this.timeToRenderStart = null;
  };
}

export const MetricsService = new MetricsServiceClass();
